import xhrCache from './cache';

export default (id) => {
  try {
    const xhr = xhrCache[id];
    xhr?.abort();
    delete xhrCache[id];
    return !!xhr;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(e);
    return false;
  }
};
